var _defs, _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 157 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b3ddee;}.cls-1,.cls-2{stroke:#0090b9;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.25,71.53,42.09,86.12c-2.35.77-2.62,2.57-.6,4L49,95.38A2.14,2.14,0,0,1,49.06,99L32.54,112.23a2.27,2.27,0,0,0-.35,3.17l3.32,4.16a2.26,2.26,0,0,0,3.21.34l16-13.2a2.14,2.14,0,0,1,3.54.89l3.15,7.73c1,2.36,2.79,2.48,4.06.27L88.92,74.81C90.54,72,89.34,70.51,86.25,71.53Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.18,56.66h-.1a.78.78,0,0,1-.68-.87L97,35.45a.78.78,0,1,1,1.55.2L96,56a.79.79,0,0,1-.78.68m-8.25,2.67a.79.79,0,0,1-.67-.37L75.43,41.36a.79.79,0,0,1,.25-1.08.78.78,0,0,1,1.08.26L87.6,58.14a.79.79,0,0,1-.67,1.19m15.61,2.54a.79.79,0,0,1-.61-.29.78.78,0,0,1,.12-1.1l15.79-12.8a.78.78,0,1,1,1,1.22L103,61.69a.76.76,0,0,1-.49.18m23.53,9.43H126l-20.42-1.7a.77.77,0,0,1-.71-.84.76.76,0,0,1,.84-.71l20.42,1.69a.79.79,0,0,1,.71.85.78.78,0,0,1-.78.71m-9.79,20.09a.82.82,0,0,1-.54-.21L100.8,76.91a.78.78,0,1,1,1.07-1.13L116.82,90a.78.78,0,0,1-.54,1.35"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 77.93,
    cy: 81.1,
    r: 66.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step4.a0e8b3e47220f78dbb69e77be511c0c2.svg";
export { ForwardRef as ReactComponent };